import React from 'react';
import { IconProps } from '../types/types';

const FIRO: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 312 312" role="img" {...props}><path d="M91.5 224.2c3.6 0 7-2 8.6-5.2l22.9-43.5H87.6c-5.4 0-9.7-4.4-9.7-9.7v-19.5c0-5.4 4.4-9.7 9.7-9.7h56l43.5-82.4c1.7-3.2 5-5.2 8.6-5.2H269C240.6 19 200.5.3 155.9.3 69.9.3.1 70 .1 156.1c0 24.4 5.6 47.6 15.7 68.2h75.7v-.1Z" fill="#9B1C2E"/><path d="M220.1 87.8c-3.6 0-7 2-8.6 5.2l-22.9 43.5H224c5.4 0 9.7 4.4 9.7 9.7v19.5c0 5.4-4.4 9.7-9.7 9.7h-56l-43.5 82.4c-1.7 3.2-5 5.2-8.6 5.2H42.6c28.4 30 68.5 48.7 113.1 48.7 86 0 155.8-69.7 155.8-155.8 0-24.4-5.6-47.6-15.7-68.2h-75.7v.1Z" fill="#9B1C2E"/></svg>
);

export default FIRO;
